import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BottomTransitionReveal } from '../../../directives/bottom-transition-reveal';

@Component({
  selector: 'app-home',
  imports: [
    RouterLink,
    BottomTransitionReveal
  ],
  templateUrl: './home.html',
  styleUrl: './home.less'
})
export class Home {

}
